<script>
	import { UserInfo } from '$lib/store.js';
	let sources = [
		{ name: 'facebook', selected: false },
		{ name: 'google', selected: false },
		{ name: 'apple', selected: false },
		{ name: 'twitter', selected: false },
		{ name: 'linkedin', selected: false },
		{ name: 'instagram', selected: false },
		{ name: 'spotify', selected: false }
	];
	$: $UserInfo.sourcesUsed = sources?.filter((s) => s.selected).map((s) => s.name);
</script>

<h1 class="text-lg text-center">Which companies do you use?</h1>
<div
	class="grid max-w-xl w-full gap-6 p-6"
	style="grid-template-columns: repeat(auto-fit, minmax(115px, 1fr)) !important;"
>
	{#each sources as source}
		<card
			class="capitalize flex flex-col items-center gap-4 font-semibold cursor-pointer"
			on:click={() => (source.selected = !source.selected)}
			style={source.selected ? 'background:#00a4ff36' : 'background:black'}
		>
			<img class="h-10 w-10" src="/logos/{source.name}_logo.svg" alt="{source.name} logo" />
			<span>{source.name}</span>
			<!-- <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 ml-auto"
          viewBox="0 0 20 20"
          fill="currentColor">
          <path
            fill-rule="evenodd"
            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
            clip-rule="evenodd" />
        </svg> -->
		</card>
	{/each}
</div>
<a
	sveltekit:prefetch
	href="/onboard/value"
	class="block mx-auto"
	disabled={!($UserInfo.sourcesUsed || []).length}
>
	<button
		class="flip block rounded-lg text-2xl font-semibold"
		disabled={!($UserInfo.sourcesUsed || []).length}
	>
		Next
	</button>
</a>
